import usePartner from '../utils/usePartner'
import cn from '../utils/cn'

import { Logo } from '@olino/design-system'
import React from 'react'

const PartnerLogo = ({ className }: { className?: string }) => {
  const { partner } = usePartner()

  const partnerLogo = partner?.displayLogo ? partner?.logo?.url : undefined

  return (
    <div className={cn('items-center justify-center lg:h-12', className)}>
      <a className="w-42 mr-5 flex h-12 flex-row" href="/">
        {partnerLogo ? (
          <>
            <div className="flex items-center ">
              <div className="flex h-full items-center justify-center overflow-hidden rounded-lg bg-white px-2 py-1">
                <img
                  src={partnerLogo}
                  alt={`Logo de ${partner?.name}`}
                  className="h-8 object-contain"
                />
              </div>
            </div>
            <div className="h-3/4 w-px bg-white" />

            <div className="flex flex-1 items-center justify-start">
              <Logo
                variant="pilliot-blanc"
                className="mr-5 h-auto max-h-8 fill-white sm:h-8 sm:max-h-none"
              />
            </div>
          </>
        ) : (
          <>
            <Logo variant="pilliot-blanc" className="mr-5 h-full fill-white" />
          </>
        )}
      </a>
    </div>
  )
}

export default PartnerLogo
